module.exports = __webpack_public_path__ + "img/card.950f9a4f.svg";